module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.a59dc008.ttf";